import axios from 'axios'

import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING, SUPPORT_EMAIL } from '../constants'
import { syncProfile } from '../store/profile'
import { track, TRACK_TAX_RETURN_START } from '../trackers'
import { handleRequestError } from './request'

export const ACTIVATE_TAX_RETURN = 'ACTIVATE_TAX_RETURN'
export const ASSIGN_TAX_RETURN_ACCOUNTANT = 'ASSIGN_TAX_RETURN_ACCOUNTANT'
export const CREATE_AND_ACTIVATE_TAX_RETURN = 'CREATE_AND_ACTIVATE_TAX_RETURN'
export const CREATE_TAX_RETURN = 'CREATE_TAX_RETURN'
export const DATA_SYNC_TAX_RETURN = 'DATA_SYNC_TAX_RETURN'
export const DELETE_TAX_RETURN = 'DELETE_TAX_RETURN'
export const RECEIVE_TAX_RETURN = 'RECEIVE_TAX_RETURN'
export const REQUEST_TAX_RETURN = 'REQUEST_TAX_RETURN'
export const REQUEST_TAX_RETURN_INVOICE = 'REQUEST_TAX_RETURN_INVOICE'
export const SAVE_TAX_RETURN = 'SAVE_TAX_RETURN'
export const SAVE_TAX_RETURN_STATUS = 'SAVE_TAX_RETURN_STATUS'
export const SAVE_TAX_RETURN_INSTALMENTS = 'SAVE_TAX_RETURN_INSTALMENTS'
export const UPDATE_AND_SAVE_TAX_RETURN = 'UPDATE_AND_SAVE_TAX_RETURN'
export const UPDATE_AND_SAVE_TAX_RETURN_STATUS = 'UPDATE_AND_SAVE_TAX_RETURN_STATUS'
export const UPDATE_TAX_RETURN_STATUS = 'UPDATE_TAX_RETURN_STATUS'
export const RECEIVE_TAX_RETURN_DEDUCTION = 'RECEIVE_TAX_RETURN_DEDUCTION'
export const CREATE_TAX_RETURN_DEDUCTION = 'CREATE_TAX_RETURN_DEDUCTION'
export const UPDATE_TAX_RETURN_DEDUCTION = 'UPDATE_TAX_RETURN_DEDUCTION'
export const INVALIDATE_TAX_RETURN = 'INVALIDATE_TAX_RETURN'

export const createTaxReturnAndActivate = (data) => (dispatch) => {
    dispatch({ type: CREATE_AND_ACTIVATE_TAX_RETURN, data })

    const { taxYear } = data

    return dispatch(createTaxReturn({ taxYear })).then(() => {
        track(TRACK_TAX_RETURN_START, { taxYear })
    })
}

export const createTaxReturn = (data) => (dispatch, getState) => {
    const { taxReturn, profile } = getState()

    const { isCreating } = taxReturn

    if (isCreating) return Promise.reject()

    dispatch({ type: CREATE_TAX_RETURN, data })

    const { id: userId } = profile

    const { taxYear } = data

    return axios
        .post('/taxreturn', { userId, taxYear })
        .then((response) => {
            const responseData = response?.data
            dispatch(
                receiveTaxReturn({
                    ...responseData,
                    shouldFetch: false,
                    isCreating: false,
                    fetchSuccessful: true,
                })
            )
            return responseData
        })
        .catch((error) => {
            dispatch(
                handleRequestError(error, {
                    customMessage: `Hubo un problema al crear tu declaración anual de ${taxYear}`,
                })
            )
            return Promise.reject(error)
        })
}

export const syncTaxReturnWithTaxOfficeData =
    (taxReturnId, meta = {}) =>
    (dispatch) => {
        dispatch({ type: DATA_SYNC_TAX_RETURN, data: { taxReturnId } })

        const { forceDownload = true } = meta

        return axios
            .put(`/taxreturns/${taxReturnId}/datasync/${forceDownload}`)
            .then((response) => {
                const responseData = response?.data
                dispatch(receiveTaxReturn(responseData))
                return responseData
            })
            .catch((error) => {
                dispatch(
                    handleRequestError(error, {
                        customMessage: `¡Ups! Ha ocurrido un error al importar tus datos fiscales. Por favor, contacta con ${SUPPORT_EMAIL} y lo solucionaremos`,
                    })
                )
                return Promise.reject(error)
            })
    }

export const requestTaxReturn = (id) => (dispatch) => {
    dispatch({ type: REQUEST_TAX_RETURN, data: { id } })

    return axios
        .get(`/taxreturns/${id}/status`)
        .then((response) => {
            const data = response?.data || {}
            dispatch(receiveTaxReturn({ ...data, fetchSuccessful: true }))
            return data
        })
        .catch((error) => {
            dispatch(receiveTaxReturn({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const requestTaxReturnInvoice = (taxReturnId) => (dispatch, getState) => {
    const { id: activeTaxReturnId } = getState().taxReturn
    const id = taxReturnId || activeTaxReturnId

    dispatch({ type: REQUEST_TAX_RETURN_INVOICE, data: { id } })

    return axios
        .get(`/taxreturns/${id}/invoice`)
        .then((response) => {
            const invoice = response?.data || {}
            dispatch(receiveTaxReturn({ invoice }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
        })
}

const receiveTaxReturn = (data) => (dispatch, getState) => {
    const { taxReturn } = getState()

    dispatch(syncProfile({ key: 'taxReturns', update: { ...taxReturn, ...data } }))

    dispatch({ type: RECEIVE_TAX_RETURN, data })
}

export const updateAndSaveTaxReturn = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_TAX_RETURN, data })

    dispatch(receiveTaxReturn(data))
    return dispatch(saveTaxReturn())
}

export const updateAndSaveActiveTaxReturn = (data) => (dispatch, getState) => {
    const { taxReturn: activeTaxReturn } = getState()

    const taxReturn = { ...activeTaxReturn, ...data }

    dispatch({ type: UPDATE_AND_SAVE_TAX_RETURN, taxReturn })

    dispatch(receiveTaxReturn(taxReturn))
    return dispatch(saveTaxReturn())
}

export const saveTaxReturn = () => (dispatch, getState) => {
    dispatch({ type: SAVE_TAX_RETURN })

    const { taxReturn } = getState()

    const { id: taxReturnId } = taxReturn

    return axios
        .put(`/taxreturns/${taxReturnId}`, taxReturn)
        .then((response) => {
            const data = response?.data || {}
            dispatch(receiveTaxReturn(data))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveTaxReturnStatus = (status) => (dispatch, getState) => {
    dispatch({ type: UPDATE_TAX_RETURN_STATUS, data: { status } })

    const { taxReturn } = getState()

    dispatch(receiveTaxReturn(taxReturn))

    const { id: taxReturnId } = taxReturn

    return dispatch(saveTaxReturnStatus({ taxReturnId, status }))
}

const saveTaxReturnStatus = (data) => (dispatch) => {
    dispatch({ type: SAVE_TAX_RETURN_STATUS, data })

    const { taxReturnId, status } = data

    return axios
        .put(`/taxreturns/${taxReturnId}/status/${status}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveTaxReturn(responseData))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const saveTaxReturnInstalments = (data) => (dispatch) => {
    dispatch({ type: SAVE_TAX_RETURN_INSTALMENTS, data })

    const { taxReturnId, payTaxInInstalments } = data

    return axios
        .put(`/taxreturns/${taxReturnId}/instalments/${!!payTaxInInstalments}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveTaxReturn(responseData))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const deleteTaxReturn = (id) => (dispatch) => {
    dispatch({ type: DELETE_TAX_RETURN, data: { id } })

    return axios.delete(`/taxreturns/${id}`).catch((error) => {
        dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
        return Promise.reject(error)
    })
}

export const assignTaxReturnAccountant = (id) => (dispatch) => {
    dispatch({ type: ASSIGN_TAX_RETURN_ACCOUNTANT, data: { id } })

    return axios
        .put(`/taxreturns/${id}/accountant`)
        .then((response) => {
            const data = response?.data || {}
            const accountantId = data?.accountantId

            if (!accountantId) return Promise.reject()

            dispatch(receiveTaxReturn(data))

            return Promise.resolve()
        })
        .catch((error) => Promise.reject(error))
}

const receiveDeduction = (deduction) => (dispatch) => {
    dispatch({ type: RECEIVE_TAX_RETURN_DEDUCTION, data: deduction })
}

export const createDeduction =
    (data = {}) =>
    (dispatch, getState) => {
        dispatch({ type: CREATE_TAX_RETURN_DEDUCTION, data })

        const { id: taxReturnId } = getState().taxReturn

        return axios
            .post(`/taxreturns/${taxReturnId}/deductions`, data)
            .then((response) => {
                const deduction = response?.data
                dispatch(receiveDeduction(deduction))
                return deduction
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const updateDeduction =
    (data = {}) =>
    (dispatch, getState) => {
        dispatch({ type: UPDATE_TAX_RETURN_DEDUCTION, data })

        const { id: taxReturnId } = getState().taxReturn

        return axios
            .put(`/taxreturns/${taxReturnId}/deductions`, data)
            .then((response) => {
                const deduction = response?.data
                dispatch(receiveDeduction(deduction))
                return deduction
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const invalidateTaxReturn = () => ({
    type: INVALIDATE_TAX_RETURN,
})
